module.exports = __webpack_public_path__ + "static/media/kendall.5a0e395b.jpg";